package fr.manyverse.app.presentation.components.common_tabs

import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.filled.Home
import androidx.compose.material3.FilledTonalIconButton
import androidx.compose.material3.Icon
import androidx.compose.material3.IconButtonDefaults
import androidx.compose.material3.MaterialTheme
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import manyverse.shared.generated.resources.Res
import manyverse.shared.generated.resources.home
import org.jetbrains.compose.resources.stringResource

@Composable
fun HomeButton(onNavigateBack: () -> Unit, modifier: Modifier = Modifier.fillMaxWidth()) {
    val homeLabel = stringResource(Res.string.home)
    Row(
        modifier = modifier,
        horizontalArrangement = Arrangement.Start,
        verticalAlignment = Alignment.CenterVertically
    ) {
        FilledTonalIconButton(
            onClick = onNavigateBack,
            colors = IconButtonDefaults.filledIconButtonColors(MaterialTheme.colorScheme.primaryContainer)
        ) {
            Icon(
                imageVector = Icons.Default.Home,
                contentDescription = homeLabel,
                tint = MaterialTheme.colorScheme.onPrimaryContainer
            )
        }
    }
}
